import { useState } from 'react';
import { Modal, Button } from 'rsuite';
import { FaRobot, FaRegFileAlt, FaWhatsapp, FaCoins } from 'react-icons/fa';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { toastError } from '../../../toasts';
import { CustomToggle } from '../../../components/CustomToggle';
import { saveConnection } from '../../../services/uniservice/uniservice.service';
import { styles } from './styles';

// Configurações de notificação (mesma conexão do WhatsApp oficial): atendimento
// automático + template automático + espelho do pedido. Salva direto via
// saveConnection e devolve a conexão atualizada pro pai.
export default function NotificationConfigModal({ open, onClose, companyId, connection, onSaved }) {
  const { theme } = useCustomTheme();
  const [saving, setSaving] = useState(false);

  const connected = Boolean(connection?.businessAccountId);

  const patch = async (payload) => {
    setSaving(true);
    try {
      onSaved(await saveConnection(companyId, payload));
    } catch {
      toastError('Não foi possível salvar a configuração');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} size="sm">
      <Modal.Header>
        <Modal.Title>Configurações de notificação</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!connected ? (
          <p style={styles.configIntro(theme)}>
            Conecte o WhatsApp oficial da loja (em <b>Conexões</b>) para configurar as notificações
            automáticas de pedido.
          </p>
        ) : (
          <>
            <p style={styles.configIntro(theme)}>
              Como o MenuCheff atende e avisa o cliente sobre o pedido pelo WhatsApp oficial.
            </p>

            <Option theme={theme} icon={<FaRobot size={16} />} title="Atendimento automático"
              description="Quando pausado, o robô não responde às palavras-chave nem envia status de pedido."
              checked={Boolean(connection.active)} disabled={saving}
              onChange={(v) => patch({ active: v })} />

            <Option theme={theme} icon={<FaRegFileAlt size={16} />} title="Template automático"
              description="Envia o template aprovado pela Meta com os detalhes do pedido para avisar o cliente fora da janela de 24h."
              checked={Boolean(connection.sendOrderTemplate)} disabled={saving}
              onChange={(v) => patch({ sendOrderTemplate: v })} />

            <Option theme={theme} icon={<FaWhatsapp size={16} />} title="Espelho do pedido"
              description="Ao finalizar a compra, redireciona o cliente pro WhatsApp da loja com um resumo do pedido pronto pra enviar. Confirma o número dele e libera as notificações seguintes sem gastar template."
              checked={Boolean(connection.sendOrderMirror)} disabled={saving}
              onChange={(v) => patch({ sendOrderMirror: v })} />

            {connection.sendOrderTemplate && !connection.sendOrderMirror && (
              <div style={styles.costHint(theme)}>
                <div style={styles.costHintIcon(theme)}><FaCoins size={13} /></div>
                <div>
                  <strong>Economize:</strong> a Meta cobra mais caro por template do que por conversa aberta
                  pelo cliente. Ative o espelho também — na maioria dos casos ele reduz seus custos de notificação.
                </div>
              </div>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button appearance="primary" onClick={onClose} style={{ backgroundColor: theme.colors.primary }}>Fechar</Button>
      </Modal.Footer>
    </Modal>
  );
}

function Option({ theme, icon, title, description, checked, onChange, disabled }) {
  return (
    <div style={styles.configCard(theme, checked)}>
      <div style={styles.configIcon(theme, checked)}>{icon}</div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={styles.configLabel(theme)}>{title}</div>
        <div style={styles.configDesc(theme)}>{description}</div>
      </div>
      <CustomToggle checked={checked} onChange={onChange} disabled={disabled} checkedChildren="Ativo" unCheckedChildren="Inativo" />
    </div>
  );
}
